import { render, staticRenderFns } from "./champagne-glass.vue?vue&type=template&id=113fd526"
import script from "./champagne-glass.vue?vue&type=script&lang=js"
export * from "./champagne-glass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports